(function () {
  'use strict';

  angular
    .module('iqxCore', [
      'auth0.auth0',
      "oc.lazyLoad",
      'ngRoute',
      'ngCookies',
      'ngMessages',
      'ngAnimate',
      'ngTouch',
      'ngSanitize',
      'ngAria',
      'ui.bootstrap',
      'ngFileUpload',
      'ui.select',
      'ngMask',
      '19degrees.ngSweetAlert2',
      'trTrustpass',
      'ngProgress',
      'angular.filter',
      'duScroll',
      'ngSentry'
    ])
})()

